import { chains, } from "..";

export * from "./Abi";
export * from "./Address";
export * from "./ChainedContract";
export * from "./TokenDefinition";
export * from "./TokenEdge";
export * from "./URL";
export * from "./SupportedChainId";
export * from "./TokenSymbol";



export declare type ChainId = keyof typeof chains;
export declare type ValidChainId = ChainId;

// @todo do this is magicy way so we accumulate the tokens as we add chains automatically
export declare type AllValidTokens = keyof typeof chains[1]["tokens"] | keyof typeof chains[4216188]["tokens"]
export declare type AnyValidToken = AllValidTokens;


const raise = ( message: string ): never => {
	throw new Error(`@bracket/addressbook : ${message}`);
}


export const isValidChainId = ( value: unknown ): value is ValidChainId => {
	return typeof value === "number" && value in chains;
}

export const assertValidChainId = ( value: unknown ): ValidChainId => {
	return isValidChainId(value) ? value : raise("ValidChainId assertion failed");
}
